import React from 'react'

interface ProfileDropdownDiscountProps {
  width?: number
  height?: number
  color?: string
}

export const ProfileDropdownDiscount = ({
  width,
  height,
  color = 'var(--color-main-dark)',
}: ProfileDropdownDiscountProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.5 20C3.1 20 2.75 19.85 2.45 19.55C2.15 19.25 2 18.9 2 18.5V14.675C2.61667 14.5417 3.12917 14.2208 3.5375 13.7125C3.94583 13.2042 4.15 12.6333 4.15 12C4.15 11.3667 3.94583 10.7917 3.5375 10.275C3.12917 9.75833 2.61667 9.44167 2 9.325V5.5C2 5.1 2.15 4.75 2.45 4.45C2.75 4.15 3.1 4 3.5 4H20.5C20.9 4 21.25 4.15 21.55 4.45C21.85 4.75 22 5.1 22 5.5V9.325C21.3833 9.44167 20.875 9.75833 20.475 10.275C20.075 10.7917 19.875 11.3667 19.875 12C19.875 12.6333 20.075 13.2042 20.475 13.7125C20.875 14.2208 21.3833 14.5417 22 14.675V18.5C22 18.9 21.85 19.25 21.55 19.55C21.25 19.85 20.9 20 20.5 20H3.5ZM3.5 18.5H20.5V15.775C19.9 15.3583 19.3958 14.8208 18.9875 14.1625C18.5792 13.5042 18.375 12.7833 18.375 12C18.375 11.2167 18.5792 10.4958 18.9875 9.8375C19.3958 9.17917 19.9 8.64167 20.5 8.225V5.5H3.5V8.225C4.1 8.64167 4.60833 9.17917 5.025 9.8375C5.44167 10.4958 5.65 11.2167 5.65 12C5.65 12.7833 5.44167 13.5042 5.025 14.1625C4.60833 14.8208 4.1 15.3583 3.5 15.775V18.5ZM9.4 16.05L12 14.025L14.6 16.05L13.6 12.85L16.05 10.8H13.05L12 7.75L10.95 10.8H7.95L10.4 12.85L9.4 16.05Z"
        fill={color}
      />
    </svg>
  )
}
